<template>
    <div class="user-team-block">
        <div class="user-team-block__avatar">
            <user-avatar
                :placeholder="placeholder"
                :url="url ? resizedToSizeUploadUrl(url, 'lg') : ''"
                :alt="userName"
            />
        </div>

        <div class="user-team-block__content">
            <text-decorator :size="FontSize.sm" bold>
                {{ userName }}
            </text-decorator>

            <text-decorator :size="FontSize.xs">
                {{ teamName }}
            </text-decorator>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import type { User, Branch } from '@keyvue/one-api-client-legacy';
    import { FontSize, UserAvatar, TextDecorator } from '@keyvue/one-ui';
    import { resizedToSizeUploadUrl } from '@/utils/resize';

    const props = defineProps<{
        user: User | null,
        team: Branch | null,
    }>();

    const abbreviatedName = computed(() => {
        if (props.user?.firstname && props.user?.lastname) {
            return props.user.firstname.substring(0, 1) + props.user.lastname.substring(0, 1);
        }

        if (props.user?.firstname) {
            return props.user.firstname.substring(0, 1);
        }

        if (props.user?.lastname) {
            return props.user.lastname.substring(0, 1);
        }

        return '?';
    });

    const placeholder = computed(() => (props.user ? abbreviatedName.value : ''));
    const url = computed(() => (props.user ? props.user.avatar : ''));
    const userName = computed(() => (props.user ? props.user.name : ''));
    const teamName = computed(() => (props.team ? props.team.name : ''));
</script>

<style lang="scss">
.user-team-block {
    display: flex;
    gap: size(sm);
    align-items: center;

    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding-right: size(xl);

    &__content {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }
}
</style>
